import { render } from "./EventRankings.vue?vue&type=template&id=9b00563c&scoped=true"
import script from "./EventRankings.vue?vue&type=script&lang=js"
export * from "./EventRankings.vue?vue&type=script&lang=js"

import "./EventRankings.vue?vue&type=style&index=0&id=9b00563c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b00563c"]])

export default __exports__